module.exports = __webpack_public_path__ + "static/media/registration__image.bcf81979.svg";